// @flow

import React from 'react'

import type { ContactPageForm } from '../../types/i18n/contact-page-form'
import { InputLabelSubtitle } from './contact-input-label'

export const contactContent: ContactPageForm = {
  form: {
    firstName: {
      label: (
        <>
          First Name <InputLabelSubtitle>(Required)</InputLabelSubtitle>
        </>
      ),
      placeholder: 'Jennifer',
    },
    lastName: {
      label: (
        <>
          Last Name <InputLabelSubtitle>(Required)</InputLabelSubtitle>
        </>
      ),
      placeholder: 'Smith',
    },
    email: {
      label: (
        <>
          Email <InputLabelSubtitle>(Required)</InputLabelSubtitle>
        </>
      ),
      placeholder: 'jennifer.smith@example.com',
    },
    phone: { label: 'Phone', placeholder: '892-555-1234' },
    message: {
      label: 'Message',
      placeholder: 'Message to owners, reservations not accepted...',
    },
    submitButton: { label: 'Send' },
    botField: {
      label: 'Don’t fill this out if you are human.',
      placeholder: 'Write message...',
    },
  },
}

export default contactContent
